import { Component, OnDestroy } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { SystemService } from "src/app/system/system.service";
import { SingleSystemModel } from "src/app/system/system";
import { Subscription } from "rxjs";
import { ConfirmationDialogComponent } from "src/app/shared/dialoges/confirmation-dialog/confirmation-dialog.component";
import { MatDialog, MatSnackBar } from "@angular/material";
@Component({
  selector: "app-view-system",
  templateUrl: "./view-system.component.html",
  styleUrls: ["./view-system.component.css"],
})
export class ViewSystemComponent implements OnDestroy {
  private subscription$ = new Subscription();
  showLoader: boolean = false;

  system: any;
  rooms: any;
  roomsTotal = 0;

  constructor(
    private route: ActivatedRoute,
    private systemService: SystemService,
    private router: Router,
    private snackBar: MatSnackBar,
    private dialog: MatDialog
  ) {}

  ngOnInit() {
    this.route.queryParams.subscribe((queryParams: any) => {
      if (queryParams?.id) {
        this.getSystemById(queryParams.id);
      }
    });
  }

  /**
   * Get System Details By Id
   */
  getSystemById(systemId: String | number) {
    this.showLoader = true;
    this.subscription$.add(
      this.systemService.getSingleSystem(systemId).subscribe(
        (result: SingleSystemModel) => {
          if (result?.system?.length) {
            this.system = result.system[0];

            //get Equipment names/ descriptions
            this.subscription$.add(
            this.systemService.getSingleEquipment(result.system[0].equipment_id).subscribe(
              (res: any) => {
                console.log(res);
                this.system.equipmentname = res.Equipment.equipmentname;
                this.system.equipmentdescription = res.Equipment.equipmentdescription;
                this.system.hrt = Math.min(
                  this.system.destotlheatgainn,
                  this.system.destotlheatgainne,
                  this.system.destotlheatgaine,
                  this.system.destotlheatgainse,
                  this.system.destotlheatgains,
                  this.system.destotlheatgainsw,
                  this.system.destotlheatgainw,
                  this.system.destotlheatgainnw
                );

                this.system.gfh = this.system.maxtotal - this.system.hrt;
              }, err=> {
                console.log('Could ont get equipment.');
              }
            )
            );

            console.log(this.system);
            //get Rooms
            this.subscription$.add(
              this.systemService.getRoom(this.system.id).subscribe(
                res=>{
                  this.rooms = res.room;
                  let sum = 0;

                  this.rooms.forEach(function(room){
                    sum += parseInt(room.dsh_heat_flow);
                  })

                  this.roomsTotal = sum;
                  console.log(this.roomsTotal);

                  console.log(res);
                },err => {
                  console.log(err)
                }
              )
            );

          }
          this.showLoader = false;
        },
        (error) => {
          this.showLoader = false;
          this.snackBar.open(`Error in Getting System Details`, "", {
            duration: 2000,
          });
        }
      )
    );
  }

  /**
   * Delete System
   * @param  {String|number} system_id
   */
  delete(systemId: String | number) {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: "300px",
    });
    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        this.showLoader = true;
        this.subscription$.add(
          this.systemService.deleteSystemById(systemId).subscribe(
            () => {
              this.router.navigate(["/system"]);
              this.showLoader = false;
              this.snackBar.open("System Deleted Sucessfully.", "", {
                duration: 2000,
              });
            },
            (error) => {
              this.showLoader = false;
              this.snackBar.open(`Error in Deleting System. `, "", {
                duration: 2000,
              });
            }
          )
        );
      }
    });
  }

  returnFixed(digit: number) {
    console.log(digit);
    return Number(digit).toFixed(1);
  }

  ngOnDestroy() {
    this.subscription$.unsubscribe();
  }
}
